import { useAuthContext } from '@/contexts/AuthContext'
import { getUserToken } from '@/lib/utils/misc'
import axios from 'axios'
import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import type { SubscriptionCheckoutUi } from '@/lib/stripeCheckoutUi'

const useSpecialButtons = () => {
  const { user } = useAuthContext()
  const router = useRouter()
  const t = useTranslations('SubscriptionCheckout')

  const [loading, setLoading] = useState(false)
  const [checkoutError, setCheckoutError] = useState<string | null>(null)
  const [clientSecret, setClientSecret] = useState<string | null>(null)
  const [checkoutUi, setCheckoutUi] = useState<SubscriptionCheckoutUi>('embedded')

  const openSubscriptionPage = () => {
    router.push('/dashboard/subscription')
  }

  const buySubscription = async (period: 'monthly' | 'yearly'): Promise<string | null> => {
    try {
      if (!user) throw new Error('Buy Button: No hay usuario')
      setLoading(true)
      setCheckoutError(null)
      const token = await getUserToken(user)

      const response = await axios.post('/api/stripe/create-checkout-session', { period }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })

      if (response.data.alreadySubscribed) {
        router.push('/dashboard/subscription')
        return null
      }

      const secret = response.data.clientSecret as string
      setCheckoutUi(response.data.uiMode === 'custom' ? 'custom' : 'embedded')
      setClientSecret(secret)
      return secret
    } catch (error) {
      console.error(error)
      setCheckoutError(axios.isAxiosError(error) && error.response?.status === 409 ? t('checkoutBusy') : t('checkoutError'))
      return null
    } finally {
      setLoading(false)
    }
  }

  const resetCheckout = () => setClientSecret(null)

  return {
    loading,
    checkoutError,
    clientSecret,
    checkoutUi,
    openBillingPortal: openSubscriptionPage,
    buySubscription,
    resetCheckout
  }
}
export default useSpecialButtons
